import { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Button, Modal, Form, Input } from "antd";
import { showAppMessage, requireAuth, showAppModal } from "~/redux/actions/app";
import { applyTalentPost, checkUser } from "~/redux/actions/talent";
import settings from "~/settings";

const { TextArea } = Input;
const PostTalentAddon = (props) => {
  const showApplyConfirmModal = () => {
    let reason = null;
    let answer = "";
    Modal.confirm({
      title: "确认申请该职位？",
      width: 700,
      content: (
        <Form layout="vertical">
          <Form.Item label="申请理由">
            <TextArea
              placeholder="你可以在这里如求职信一样，填写自己的附加求职信息（选填）"
              onChange={(e) => {
                reason = e.target.value;
              }}
              rows={5}
            />
            {props.opening && props.opening.question && (
              <Form.Item
                label={`雇主问题：${props.opening.question}`}
                required
                labelAlign="left"
                className="mt-10"
              >
                <TextArea
                  placeholder="雇主问题是雇主向您询问的问题，请根据自身情况如实填写"
                  onChange={(e) => {
                    answer = e.target.value;
                  }}
                  rows={5}
                />
              </Form.Item>
            )}
          </Form.Item>
        </Form>
      ),
      onOk(close) {
        if (props.opening && props.opening.question && !answer.trim()) {
          props.showAppMessage("请输入雇主问题的答案", "info");
          return;
        }
        props.applyTalentPost(
          props.token,
          props.post.id,
          reason,
          answer,
          "web"
        );
        close();
      },
      onCancel() {},
    });
  };

  const showGoToTalentModel = () => {
    Modal.confirm({
      title: !props.checkUserResult.completed
        ? "请先前往远程人才库完善简历基本信息"
        : props.checkUserResult.proportion < props.checkUserResult.required &&
          `简历完成度${props.checkUserResult.required}%以上才可进行职位申请操作，您现在的完成度为${props.checkUserResult.proportion}%，请先前往远程人才库完善简历信息。`,
      onOk() {
        window.location.href = `${settings.talentUrl}/me/profile?pid=${props.post.id}`;
      },
      onCancel() {},
    });
  };

  useEffect(() => {
    if (props.token) {
      props.checkUser(props.token, props.post.id);
    }
  }, [props.token]);

  return (
    <div className="text-center py-20 mb-5">
      {!props.checkUserResult.applied || !props.token ? (
        <Button
          type="primary"
          onClick={() => {
            if (props.token) {
              if (
                props.checkUserResult.detailed &&
                props.checkUserResult.completed &&
                props.checkUserResult.proportion >=
                  props.checkUserResult.required
              ) {
                showApplyConfirmModal();
              } else {
                showGoToTalentModel();
              }
            } else {
              props.showAppModal("PhoneSigninModal");
            }
          }}
        >
          申请该职位
        </Button>
      ) : (
        <Button type="primary" disabled>
          您已申请过该职位
        </Button>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
  talent: state.talent,
  checkUserResult: state.talent.checkUserResult,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAppMessage,
      requireAuth,
      showAppModal,
      applyTalentPost,
      checkUser,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PostTalentAddon);
